__turbopack_context__.v({
  "errorBox": "styles-module__jMS92W__errorBox",
});
